// Textos de dinero: depósitos, retiros, wallet y modales. Claves: dep.*, retiro.*, wallet.*, modal.*, srv:*

export default {
  es: {
    'dep.copiar': 'Copiar',
    'dep.copiado': 'Copiado',
    'dep.estAprobado': 'Aprobado',
    'dep.estRechazado': 'Rechazado',
    'dep.estRevision': 'En revisión',
    'dep.tipoInternacional': 'Transferencia internacional',
    'dep.tipoRemesa': 'Remesa',
    'dep.tipoAchPanama': 'ACH Panamá',
    'dep.vacioTitulo': 'Aún no tienes depósitos.',
    'dep.vacioAyuda': 'Envía USDT a una dirección de Panther7 y avísanos en el paso 2 para acreditarlo.',
    'dep.buscar': 'Buscar por fecha, estado o monto',
    'dep.buscarAria': 'Buscar depósitos',
    'dep.paginas': 'Páginas',
    'dep.pagAnterior': 'Página anterior',
    'dep.pagSiguiente': 'Página siguiente',
    'dep.pagina': '{pagina} de {maximo}',
    'dep.colFecha': 'Fecha',
    'dep.colDetalle': 'Detalle',
    'dep.colMonto': 'Monto',
    'dep.colEstado': 'Estado',
    'dep.motivo': 'Motivo: {motivo}',
    'dep.depositoUno': '{n} depósito',
    'dep.depositoVarios': '{n} depósitos',
    'dep.titulo': 'Depósito',
    'dep.subtitulo': 'Seleccione una opción para continuar',
    'dep.tabMis': 'Mis depósitos',
    'dep.tabDonde': 'USDT: dónde enviar',
    'dep.tabAvisar': 'USDT: avisar mi envío',
    'dep.tabAch': 'ACH Panamá',
    'dep.achArchivoGrande': 'El archivo no debe superar los 4 MB.',
    'dep.achFormato': 'Usa un archivo JPG, PNG o PDF.',
    'dep.achSinComprobante': 'Adjunta el comprobante de la transferencia.',
    'dep.achReportado': 'Depósito reportado.',
    'dep.achNoSePudo': 'No se pudo reportar el depósito. Intenta de nuevo.',
    'dep.achRevisamos': 'Lo revisaremos y lo acreditaremos en tu wallet en USDT (1 a 1). Verás el estado en "Mis depósitos".',
    'dep.achReportarOtro': 'Reportar otro',
    'dep.achVerMis': 'Ver mis depósitos',
    'dep.achPaso1': '1. Transfiere a esta cuenta',
    'dep.cargandoDatos': 'Cargando datos…',
    'dep.achSinDatos': 'Los datos bancarios aún no están disponibles. Escríbenos a soporte para recibirlos.',
    'dep.achBanco': 'Banco',
    'dep.achTitular': 'Titular',
    'dep.achCuenta': 'Cuenta',
    'dep.achCuentaTipo': 'Cuenta {tipo}',
    'dep.achAyuda': 'Tu depósito se acredita 1 a 1 en USDT. Transfiere desde una cuenta a tu nombre.',
    'dep.achPaso2': '2. Avísanos cuando lo envíes',
    'dep.achMonto': 'Monto transferido (USDT)',
    'dep.achPhMonto': 'Ej: 500.00',
    'dep.achBancoOrigen': 'Banco desde el que enviaste',
    'dep.achPhBanco': 'Escribe o elige tu banco',
    'dep.achFecha': 'Fecha de la transferencia',
    'dep.achReferencia': 'Número de referencia o confirmación',
    'dep.achComprobante': 'Comprobante (JPG, PNG o PDF, máx. 4 MB)',
    'dep.enviando': 'Enviando…',
    'dep.achReportar': 'Reportar depósito',
    'dep.dirError': 'Error al cargar las direcciones. Por favor, intenta nuevamente.',
    'dep.noDisponible': 'No disponible',
    'dep.cargandoSr': 'Cargando...',
    'dep.dirCargando': 'Cargando direcciones de depósito...',
    'dep.reintentar': 'Reintentar',
    'dep.dirNinguna': 'No hay direcciones disponibles',
    'dep.dirColDireccion': 'Dirección',
    'dep.dirColAccion': 'Acción',
    'dep.dirColNetwork': 'Network',
    'dep.dirAyuda1': 'Para efectuar créditos de USDT a su wallet, utilice una de las direcciones establecidas.',
    'dep.dirAyuda2': 'Una vez enviados los USDT, siga los pasos en',
    'dep.dirAyuda3': 'Los reportes de depósitos serán procesados en un máximo de',
    'dep.dirHoras': '6 horas hábiles',
    'dep.ejMonto100': 'Ej: 100.00',
    'dep.archivoGrande4': 'El archivo no debe superar los 4MB',
    'dep.formatoNoPermitido': 'Formato no permitido. Use JPG, PNG o PDF',
    'dep.montoInvalido': 'Por favor, ingrese un monto válido',
    'dep.sinComprobante': 'Por favor, cargue el comprobante de la transacción',
    'dep.errorSolicitud': 'Error al procesar la solicitud',
    'dep.reportarBtn': '📤 Reportar Depósito',
    'dep.estaReportando': '💰 Está reportando un depósito de',
    'dep.comprobante': 'Comprobante',
    'dep.clickCargar': 'Click o arrastra para cargar el comprobante',
    'dep.formatosPermitidos': 'Formatos permitidos: JPG, PNG, PDF. Tamaño máximo: 4MB',
    'dep.panTitulo': 'Reportar Depósitos',
    'dep.panSub': 'Haga una transferencia cripto a la dirección especificada y reporte su transacción',
    'dep.panReqMonto': '💰 Monto',
    'dep.panReqMontoSub': 'Monto enviado en USDT',
    'dep.panReqDir': '📍 Dirección USDT',
    'dep.panReqDirSub': 'Dirección donde envió los fondos',
    'dep.panReqHash': '🔗 Hash',
    'dep.panReqHashSub': 'Hash generado por la transacción',
    'dep.panReqComp': '📎 Comprobante',
    'dep.panReqCompSub': 'Imagen o PDF de la transacción',
    'dep.panMonto': 'Monto (USDT)',
    'dep.panCualDir': '¿A cuál dirección de Panther enviaste?',
    'dep.panSelDir': 'Selecciona la dirección',
    'dep.panDirAyuda': 'Es la dirección que te dimos para depositar, no la tuya. Así sabemos en qué red llegó.',
    'dep.panHashLabel': 'Hash de Transacción',
    'dep.panHashPh': 'Hash de la transacción en la blockchain',
    'dep.panSelDirMsg': 'Selecciona la dirección de Panther a la que enviaste',
    'dep.panHashMsg': 'Por favor, ingrese el hash de la transacción',
    'dep.vistaPrevia': 'Preview',
    'dep.intTitulo': 'Transferencia Internacional',
    'dep.intIntro1': 'Complete la siguiente información para reportar su transferencia internacional.',
    'dep.intIntro2': 'Deberá indicar el',
    'dep.intIntroMonto': 'monto',
    'dep.intIntroUna': 'una',
    'dep.intIntroRef': 'referencia',
    'dep.intIntroAdj': 'y adjuntar el',
    'dep.intIntroComp': 'comprobante bancario',
    'dep.intMonto': 'Monto (USDT)',
    'dep.intRef': 'Referencia',
    'dep.intPhRef': 'Ej: TRANSFER-12345',
    'retiro.error': 'Error al procesar el retiro',
    'retiro.solicitarBtn': 'Solicitar Retiro',
    'retiro.titulo': 'Nuevo retiro',
    'retiro.subtitulo': 'Seleccione el tipo de retiro a realizar',
    'retiro.todos': 'Todos mis retiros',
    'retiro.listado': 'Listado de retiros',
    'retiro.nacional': 'Transferencia Nacional',
    'retiro.panama': 'Panamá',
    'retiro.internacional': 'Transferencia Internacional',
    'retiro.global': 'Global',
    'retiro.cripto': 'Transferencia Cripto',
    'retiro.infoTodos': 'Sus retiros hechos hasta la fecha',
    'retiro.infoNacional': 'Para hacer retiros a cuentas Nacionales en Panamá',
    'retiro.infoInternacional': 'Para hacer retiros a cuentas Internacionales en todo el mundo',
    'retiro.infoCripto': 'Para hacer retiros por cripto USDT',
    'retiro.listaTitulo': 'Todos tus retiros',
    'retiro.colCodigo': 'CÓDIGO',
    'retiro.colFecha': 'FECHA',
    'retiro.colBeneficiario': 'BENEFICIARIO',
    'retiro.colInfo': 'INFORMACIÓN',
    'retiro.colMoneda': 'MONEDA',
    'retiro.colMonto': 'MONTO',
    'retiro.colEstado': 'ESTADO',
    'retiro.colBanco': 'BANCO',
    'retiro.colTitular': 'TITULAR',
    'retiro.colCuenta': 'CUENTA',
    'retiro.colTipo': 'TIPO',
    'retiro.colSeleccion': 'SELECCION',
    'retiro.colNombre': 'NOMBRE',
    'retiro.colRed': 'RED',
    'retiro.colDireccion': 'DIRECCIÓN',
    'retiro.selBeneficiario': 'Seleccione beneficiario',
    'retiro.addBeneficiario': 'Añadir beneficiario',
    'retiro.retirar': 'Retirar',
    'retiro.retirarUsdt': 'Retirar USDT',
    'retiro.nuevaWallet': '+ Nueva wallet',
    'retiro.sinWallets': 'Aún no tienes wallets guardadas.',
    'retiro.sinWalletsAyuda': 'Agrega la wallet donde quieres recibir tus USDT.',
    'retiro.primeraWallet': 'Agregar mi primera wallet',
    'srv:TRANSFERENCIA NACIONAL': 'TRANSFERENCIA NACIONAL',
    'srv:TRANSFERENCIA INTERNACIONAL': 'TRANSFERENCIA INTERNACIONAL',
    'wallet.noAsignada': 'No asignada',
    'wallet.estCompletada': 'Completada',
    'wallet.estPendiente': 'Pendiente',
    'wallet.estFallida': 'Fallida',
    'wallet.titulo': 'Mi wallet',
    'wallet.subtitulo': 'Tu saldo en USDT y cada movimiento de tokens, registrado en la blockchain.',
    'wallet.tarjetaAria': 'Tarjeta de wallet',
    'wallet.redPruebas': 'Red de pruebas Sepolia',
    'wallet.saldo': 'Saldo disponible',
    'wallet.titular': 'Titular',
    'wallet.sinUsuario': 'Sin usuario asignado',
    'wallet.direccion': 'Dirección',
    'wallet.copiada': 'Copiada',
    'wallet.copiar': 'Copiar',
    'wallet.ver': 'Ver',
    'wallet.totalTransferido': 'Total transferido',
    'wallet.completadas': 'Completadas',
    'wallet.pendientes': 'Pendientes',
    'wallet.nota': 'Estás en una red de pruebas: estos tokens no tienen valor real.',
    'wallet.historial': 'Historial de transferencias',
    'wallet.enTotal': '{n} en total',
    'wallet.sinTransferencias': 'Sin transferencias todavía',
    'wallet.sinTransferenciasAyuda': 'Cuando inviertas o vendas, cada movimiento de tokens aparecerá aquí.',
    'wallet.proyecto': 'Proyecto #{id}',
    'wallet.para': 'Para {usuario} · ',
    'wallet.verMenos': 'Ver menos',
    'wallet.verTodas': 'Ver las {n}',
    'modal.retiroAria': 'Solicitar retiro',
    'modal.cerrar': 'Cerrar',
    'modal.retirarUsdt': 'Retirar USDT',
    'modal.retirarBanco': 'Retirar a cuenta bancaria',
    'modal.seEnviaWallet': 'Se enviará a una wallet que ya guardaste.',
    'modal.seEnviaCuenta': 'Se enviará a una cuenta que ya guardaste.',
    'modal.wallet': 'Wallet',
    'modal.red': 'Red',
    'modal.direccion': 'Dirección',
    'modal.banco': 'Banco',
    'modal.tipoCuenta': 'Tipo de cuenta',
    'modal.titular': 'Titular',
    'modal.numCuenta': 'Número de cuenta',
    'modal.cuantoRetirar': '¿Cuánto quieres retirar?',
    'modal.disponible': 'Disponible:',
    'modal.retirarTodo': 'Retirar todo',
    'modal.excede': 'El monto supera tu saldo disponible.',
    'modal.recibirasWallet': 'Recibirás en tu wallet',
    'modal.seEnviaATuCuenta': 'Se enviará a tu cuenta',
    'modal.nota1': 'Panther7 no cobra comisión por retirar.',
    'modal.nota2': 'La red puede cobrar una tasa al ejecutar el envío.',
    'modal.nota3': 'Lo verás reflejado en un máximo de 24 horas hábiles.',
    'modal.cancelar': 'Cancelar',
    'modal.enviando': 'Enviando…',
    'modal.solicitarRetiro': 'Solicitar retiro',
    'modal.wDirCorta': 'Revisa la dirección: parece incompleta.',
    'modal.wNoGuardada': 'No se pudo guardar la wallet. Intenta de nuevo.',
    'modal.wTitulo': 'Nueva wallet USDT',
    'modal.wAyuda': 'Solo podrás retirar a wallets guardadas aquí. Verifica bien la red y la dirección: un envío a la red equivocada no se puede recuperar.',
    'modal.wAlias': 'Nombre para reconocerla',
    'modal.wAliasPh': 'Ej: Mi wallet Binance',
    'modal.wDirLabel': 'Dirección de la wallet',
    'modal.wDirPh': 'Pega la dirección completa',
    'modal.guardando': 'Guardando…',
    'modal.wGuardar': 'Guardar wallet',
    'modal.cAhorros': 'Ahorros',
    'modal.cCorriente': 'Corriente',
    'modal.cCuentaCorta': 'Revisa el número de cuenta: parece incompleto.',
    'modal.cSelPais': 'Selecciona el país del banco.',
    'modal.cNoGuardada': 'No se pudo guardar la cuenta. Intenta de nuevo.',
    'modal.cTituloInt': 'Nueva cuenta internacional',
    'modal.cTituloNac': 'Nueva cuenta en Panamá',
    'modal.cAyudaInt': 'Cuenta bancaria fuera de Panamá. Revisa el SWIFT y el número de cuenta antes de guardar.',
    'modal.cAyudaNac': 'Cuenta bancaria a tu nombre en un banco de Panamá.',
    'modal.cTitular': 'Titular de la cuenta',
    'modal.cPais': 'País del banco',
    'modal.cSelPaisOpt': 'Selecciona un país',
    'modal.cBancoPh': 'Elige o escribe el banco',
    'modal.cSwift': 'Código SWIFT / BIC',
    'modal.cAba': 'ABA o ruta (opcional)',
    'modal.cGuardar': 'Guardar cuenta',
    'modal.mOficinas': 'Oficinas Master Money',
    'modal.mOficina': 'Oficina',
    'modal.mComoLlegar': 'Cómo llegar',
    'dep.oldEnviar': 'Enviar',
    'dep.oldTitulo': 'Nuevo depósito',
    'dep.oldSubtitulo': 'Seleccione el tipo de depósito a realizar',
    'dep.oldTodos': 'Todos mis depósitos',
    'dep.oldListado': 'Listado de depósitos',
    'dep.oldAch': 'ACH / PANAMÁ',
    'dep.oldBancaInt': 'Transferencia bancaria internacional',
    'dep.oldInfoTodos': 'Sus depósitos hechos hasta la fecha',
    'dep.oldInfoInt': 'Para reportar depósitos hechos a la cuenta Panther en el exterior...',
    'dep.oldInfoAch': 'Para reportar depósitos vía ACH / PANAMÁ...',
    'dep.oldTipCodigo': 'Código de referencia',
    'dep.oldTipFecha': 'Fecha del depósito',
    'dep.oldTipInfo': 'Información de depósito',
    'dep.oldTipMoneda': 'Moneda',
    'dep.oldTipMonto': 'Monto',
    'dep.oldTipEstado': 'Estado del movimiento',
    'dep.oldColCodigo': 'CODIGO',
    'dep.oldColFecha': 'FECHA',
    'dep.oldColInfo': 'INFORMACION',
    'dep.oldColMoneda': 'MONEDA',
    'dep.oldColMonto': 'MONTO',
    'dep.oldColEstado': 'ESTADO DEL MOVIMIENTO',
    'dep.oldListaTitulo': 'Todos tus depósitos',
    'dep.oldSinDep': 'Sin depósitos',
    'dep.oldSinDepSub': 'Todavía no ha hecho ningún depósito',
    'dep.oldSinDepAyuda': 'Para depósitar dinero de su cuenta Panther 7, por favor seleccione el tipo de envío y siga intuitivamente los pasos',
    'dep.oldRegistrarInt': 'REGISTRAR TRANSFERENCIA NUEVA DIRECCION',
    'dep.oldBancoReceptor': 'Banco Receptor:',
    'dep.oldBancoBenef': 'Banco Beneficiario:',
    'dep.oldNumCuenta': 'Número de Cuenta:',
    'dep.oldCreditoAd': 'Crédito Adicional a:',
    'dep.oldRefCredito': 'Referencia de Crédito:',
    'dep.oldHaciendo': 'Usted está haciendo un deposito con el monto',
    'dep.oldMonto': 'Monto',
    'dep.oldElegirMoneda': 'Elegir Moneda',
    'dep.oldPhMonto': 'Digite el monto',
    'dep.oldPhMontoEnviar': 'Digite el monto a enviar',
    'dep.oldMoneda': 'Moneda',
    'dep.oldCargarComp': 'Cargar el comprobante',
    'dep.oldEjem': 'Ejem .JPG .PDF \'Tamaño Maximo del archivo: 4mb\'',
    'dep.oldRegistrarAch': 'REGISTRAR DEPÓSITO ACH / PANAMÁ',
    'dep.oldMax1': 'El monto máximo por depósito es de',
    'dep.old3000': '3000 USDT',
    'dep.oldMax2': 'Para depósitos mayores a',
    'dep.oldMax3': 'comuníquese a nuestro correo info@panther7.com',
    'dep.oldDemo': 'Esto es una plataforma de demostración, el saldo y las operaciones no son reales.',
    'dep.oldPaypal': 'Pagar con PayPal',
    'dep.oldPaypalRapida': 'La forma más rápida y segura de Pagar',
    'dep.oldPaypalComision': 'Los depósitos por Paypal tienen una comisión operativa del 5.5%.',
    'dep.oldPaypalEjemplo': 'Por ejemplo: si usted deposita $100, se harán efectivos en su cuenta Panther 7: $94.5',
    'dep.oldRemesadora': 'DEPOSITO VÍA REMESADORA',
    'dep.oldPasos': 'Pasos para proceder a realizar el deposito vía Master Money',
    'dep.oldPaso1': 'Diríjase al Master Money más cercano. Ver listado de oficinas',
    'dep.oldPaso2': 'Debe ir con una identificación vigente.',
    'dep.oldPaso3': 'Notificarle al operador Master Money el numero de autorización (PantherPIN)',
    'dep.oldPaso4': 'Entréguele al operador Master Money el valor de su envió a deposito',
    'dep.oldPaso5': 'Al procesar su remesa, reciba su copia de envió y su deposito estará disponible en su wallet Panther 7 en efectivo en un máximo de 30 minutos.',
    'dep.oldPaso6': 'Toda la información será enviada vía correo electrónico',
    'dep.oldAceptar': 'Aceptar',
    'srv:Tiene un depósito en tránsito. Verifique depósitos ya generados': 'Tiene un depósito en tránsito. Verifique depósitos ya generados',
    'srv:Depósito reportado con éxito': 'Depósito reportado con éxito',
    'srv:Seleccione una wallet USDT guardada en su cuenta.': 'Seleccione una wallet USDT guardada en su cuenta.',
    'srv:Solicitud de retiro creado con éxito': 'Solicitud de retiro creado con éxito',
    'srv:Saldo insuficiente': 'Saldo insuficiente',
    'srv:Retiro creado con exito': 'Retiro creado con exito',
    'srv:En las próximas 24 horas su solicitud de transferencia será procesada.': 'En las próximas 24 horas su solicitud de transferencia será procesada.',
  },
  en: {
    'dep.copiar': 'Copy',
    'dep.copiado': 'Copied',
    'dep.estAprobado': 'Approved',
    'dep.estRechazado': 'Rejected',
    'dep.estRevision': 'Under review',
    'dep.tipoInternacional': 'International transfer',
    'dep.tipoRemesa': 'Remittance',
    'dep.tipoAchPanama': 'ACH Panama',
    'dep.vacioTitulo': 'You don\'t have any deposits yet.',
    'dep.vacioAyuda': 'Send USDT to a Panther7 address and let us know in step 2 so we can credit it.',
    'dep.buscar': 'Search by date, status or amount',
    'dep.buscarAria': 'Search deposits',
    'dep.paginas': 'Pages',
    'dep.pagAnterior': 'Previous page',
    'dep.pagSiguiente': 'Next page',
    'dep.pagina': '{pagina} of {maximo}',
    'dep.colFecha': 'Date',
    'dep.colDetalle': 'Details',
    'dep.colMonto': 'Amount',
    'dep.colEstado': 'Status',
    'dep.motivo': 'Reason: {motivo}',
    'dep.depositoUno': '{n} deposit',
    'dep.depositoVarios': '{n} deposits',
    'dep.titulo': 'Deposit',
    'dep.subtitulo': 'Select an option to continue',
    'dep.tabMis': 'My deposits',
    'dep.tabDonde': 'USDT: where to send',
    'dep.tabAvisar': 'USDT: report my transfer',
    'dep.tabAch': 'ACH Panama',
    'dep.achArchivoGrande': 'The file must not exceed 4 MB.',
    'dep.achFormato': 'Use a JPG, PNG or PDF file.',
    'dep.achSinComprobante': 'Attach the transfer receipt.',
    'dep.achReportado': 'Deposit reported.',
    'dep.achNoSePudo': 'We couldn\'t report the deposit. Please try again.',
    'dep.achRevisamos': 'We will review it and credit it to your wallet in USDT (1 to 1). You will see the status in "My deposits".',
    'dep.achReportarOtro': 'Report another',
    'dep.achVerMis': 'View my deposits',
    'dep.achPaso1': '1. Transfer to this account',
    'dep.cargandoDatos': 'Loading data…',
    'dep.achSinDatos': 'The bank details are not available yet. Contact support to receive them.',
    'dep.achBanco': 'Bank',
    'dep.achTitular': 'Account holder',
    'dep.achCuenta': 'Account',
    'dep.achCuentaTipo': 'Account ({tipo})',
    'dep.achAyuda': 'Your deposit is credited 1 to 1 in USDT. Transfer from an account in your name.',
    'dep.achPaso2': '2. Let us know when you send it',
    'dep.achMonto': 'Amount transferred (USDT)',
    'dep.achPhMonto': 'e.g. 500.00',
    'dep.achBancoOrigen': 'Bank you sent from',
    'dep.achPhBanco': 'Type or choose your bank',
    'dep.achFecha': 'Transfer date',
    'dep.achReferencia': 'Reference or confirmation number',
    'dep.achComprobante': 'Receipt (JPG, PNG or PDF, max. 4 MB)',
    'dep.enviando': 'Sending…',
    'dep.achReportar': 'Report deposit',
    'dep.dirError': 'Error loading the addresses. Please try again.',
    'dep.noDisponible': 'Not available',
    'dep.cargandoSr': 'Loading...',
    'dep.dirCargando': 'Loading deposit addresses...',
    'dep.reintentar': 'Retry',
    'dep.dirNinguna': 'No addresses available',
    'dep.dirColDireccion': 'Address',
    'dep.dirColAccion': 'Action',
    'dep.dirColNetwork': 'Network',
    'dep.dirAyuda1': 'To credit USDT to your wallet, use one of the established addresses.',
    'dep.dirAyuda2': 'Once the USDT has been sent, follow the steps in',
    'dep.dirAyuda3': 'Deposit reports will be processed within a maximum of',
    'dep.dirHoras': '6 business hours',
    'dep.ejMonto100': 'e.g. 100.00',
    'dep.archivoGrande4': 'The file must not exceed 4MB',
    'dep.formatoNoPermitido': 'Format not allowed. Use JPG, PNG or PDF',
    'dep.montoInvalido': 'Please enter a valid amount',
    'dep.sinComprobante': 'Please upload the transaction receipt',
    'dep.errorSolicitud': 'Error processing the request',
    'dep.reportarBtn': '📤 Report Deposit',
    'dep.estaReportando': '💰 You are reporting a deposit of',
    'dep.comprobante': 'Receipt',
    'dep.clickCargar': 'Click or drag to upload the receipt',
    'dep.formatosPermitidos': 'Allowed formats: JPG, PNG, PDF. Maximum size: 4MB',
    'dep.panTitulo': 'Report Deposits',
    'dep.panSub': 'Make a crypto transfer to the specified address and report your transaction',
    'dep.panReqMonto': '💰 Amount',
    'dep.panReqMontoSub': 'Amount sent in USDT',
    'dep.panReqDir': '📍 USDT address',
    'dep.panReqDirSub': 'Address where you sent the funds',
    'dep.panReqHash': '🔗 Hash',
    'dep.panReqHashSub': 'Hash generated by the transaction',
    'dep.panReqComp': '📎 Receipt',
    'dep.panReqCompSub': 'Image or PDF of the transaction',
    'dep.panMonto': 'Amount (USDT)',
    'dep.panCualDir': 'Which Panther address did you send to?',
    'dep.panSelDir': 'Select the address',
    'dep.panDirAyuda': 'This is the address we gave you to deposit to, not yours. This way we know which network it arrived on.',
    'dep.panHashLabel': 'Transaction Hash',
    'dep.panHashPh': 'Transaction hash on the blockchain',
    'dep.panSelDirMsg': 'Select the Panther address you sent to',
    'dep.panHashMsg': 'Please enter the transaction hash',
    'dep.vistaPrevia': 'Preview',
    'dep.intTitulo': 'International Transfer',
    'dep.intIntro1': 'Complete the following information to report your international transfer.',
    'dep.intIntro2': 'You must enter the',
    'dep.intIntroMonto': 'amount',
    'dep.intIntroUna': 'a',
    'dep.intIntroRef': 'reference',
    'dep.intIntroAdj': 'and attach the',
    'dep.intIntroComp': 'bank receipt',
    'dep.intMonto': 'Amount (USDT)',
    'dep.intRef': 'Reference',
    'dep.intPhRef': 'e.g. TRANSFER-12345',
    'retiro.error': 'Error processing the withdrawal',
    'retiro.solicitarBtn': 'Request Withdrawal',
    'retiro.titulo': 'New withdrawal',
    'retiro.subtitulo': 'Select the type of withdrawal to make',
    'retiro.todos': 'All my withdrawals',
    'retiro.listado': 'List of withdrawals',
    'retiro.nacional': 'National Transfer',
    'retiro.panama': 'Panama',
    'retiro.internacional': 'International Transfer',
    'retiro.global': 'Global',
    'retiro.cripto': 'Crypto Transfer',
    'retiro.infoTodos': 'Your withdrawals to date',
    'retiro.infoNacional': 'To make withdrawals to national accounts in Panama',
    'retiro.infoInternacional': 'To make withdrawals to international accounts worldwide',
    'retiro.infoCripto': 'To make withdrawals via USDT crypto',
    'retiro.listaTitulo': 'All your withdrawals',
    'retiro.colCodigo': 'CODE',
    'retiro.colFecha': 'DATE',
    'retiro.colBeneficiario': 'BENEFICIARY',
    'retiro.colInfo': 'INFORMATION',
    'retiro.colMoneda': 'CURRENCY',
    'retiro.colMonto': 'AMOUNT',
    'retiro.colEstado': 'STATUS',
    'retiro.colBanco': 'BANK',
    'retiro.colTitular': 'HOLDER',
    'retiro.colCuenta': 'ACCOUNT',
    'retiro.colTipo': 'TYPE',
    'retiro.colSeleccion': 'SELECTION',
    'retiro.colNombre': 'NAME',
    'retiro.colRed': 'NETWORK',
    'retiro.colDireccion': 'ADDRESS',
    'retiro.selBeneficiario': 'Select beneficiary',
    'retiro.addBeneficiario': 'Add beneficiary',
    'retiro.retirar': 'Withdraw',
    'retiro.retirarUsdt': 'Withdraw USDT',
    'retiro.nuevaWallet': '+ New wallet',
    'retiro.sinWallets': 'You don\'t have any saved wallets yet.',
    'retiro.sinWalletsAyuda': 'Add the wallet where you want to receive your USDT.',
    'retiro.primeraWallet': 'Add my first wallet',
    'srv:TRANSFERENCIA NACIONAL': 'NATIONAL TRANSFER',
    'srv:TRANSFERENCIA INTERNACIONAL': 'INTERNATIONAL TRANSFER',
    'wallet.noAsignada': 'Not assigned',
    'wallet.estCompletada': 'Completed',
    'wallet.estPendiente': 'Pending',
    'wallet.estFallida': 'Failed',
    'wallet.titulo': 'My wallet',
    'wallet.subtitulo': 'Your USDT balance and every token movement, recorded on the blockchain.',
    'wallet.tarjetaAria': 'Wallet card',
    'wallet.redPruebas': 'Sepolia test network',
    'wallet.saldo': 'Available balance',
    'wallet.titular': 'Holder',
    'wallet.sinUsuario': 'No user assigned',
    'wallet.direccion': 'Address',
    'wallet.copiada': 'Copied',
    'wallet.copiar': 'Copy',
    'wallet.ver': 'View',
    'wallet.totalTransferido': 'Total transferred',
    'wallet.completadas': 'Completed',
    'wallet.pendientes': 'Pending',
    'wallet.nota': 'You are on a test network: these tokens have no real value.',
    'wallet.historial': 'Transfer history',
    'wallet.enTotal': '{n} in total',
    'wallet.sinTransferencias': 'No transfers yet',
    'wallet.sinTransferenciasAyuda': 'When you invest or sell, every token movement will appear here.',
    'wallet.proyecto': 'Project #{id}',
    'wallet.para': 'To {usuario} · ',
    'wallet.verMenos': 'View less',
    'wallet.verTodas': 'View all {n}',
    'modal.retiroAria': 'Request withdrawal',
    'modal.cerrar': 'Close',
    'modal.retirarUsdt': 'Withdraw USDT',
    'modal.retirarBanco': 'Withdraw to bank account',
    'modal.seEnviaWallet': 'It will be sent to a wallet you have already saved.',
    'modal.seEnviaCuenta': 'It will be sent to an account you have already saved.',
    'modal.wallet': 'Wallet',
    'modal.red': 'Network',
    'modal.direccion': 'Address',
    'modal.banco': 'Bank',
    'modal.tipoCuenta': 'Account type',
    'modal.titular': 'Account holder',
    'modal.numCuenta': 'Account number',
    'modal.cuantoRetirar': 'How much do you want to withdraw?',
    'modal.disponible': 'Available:',
    'modal.retirarTodo': 'Withdraw all',
    'modal.excede': 'The amount exceeds your available balance.',
    'modal.recibirasWallet': 'You will receive in your wallet',
    'modal.seEnviaATuCuenta': 'It will be sent to your account',
    'modal.nota1': 'Panther7 does not charge a fee for withdrawals.',
    'modal.nota2': 'The network may charge a fee when executing the transfer.',
    'modal.nota3': 'You will see it reflected within a maximum of 24 business hours.',
    'modal.cancelar': 'Cancel',
    'modal.enviando': 'Sending…',
    'modal.solicitarRetiro': 'Request withdrawal',
    'modal.wDirCorta': 'Check the address: it looks incomplete.',
    'modal.wNoGuardada': 'We couldn\'t save the wallet. Please try again.',
    'modal.wTitulo': 'New USDT wallet',
    'modal.wAyuda': 'You can only withdraw to wallets saved here. Double-check the network and the address: a transfer sent to the wrong network cannot be recovered.',
    'modal.wAlias': 'Name to recognize it',
    'modal.wAliasPh': 'e.g. My Binance wallet',
    'modal.wDirLabel': 'Wallet address',
    'modal.wDirPh': 'Paste the full address',
    'modal.guardando': 'Saving…',
    'modal.wGuardar': 'Save wallet',
    'modal.cAhorros': 'Savings',
    'modal.cCorriente': 'Checking',
    'modal.cCuentaCorta': 'Check the account number: it looks incomplete.',
    'modal.cSelPais': 'Select the bank\'s country.',
    'modal.cNoGuardada': 'We couldn\'t save the account. Please try again.',
    'modal.cTituloInt': 'New international account',
    'modal.cTituloNac': 'New account in Panama',
    'modal.cAyudaInt': 'Bank account outside Panama. Check the SWIFT code and the account number before saving.',
    'modal.cAyudaNac': 'Bank account in your name at a Panamanian bank.',
    'modal.cTitular': 'Account holder',
    'modal.cPais': 'Bank country',
    'modal.cSelPaisOpt': 'Select a country',
    'modal.cBancoPh': 'Choose or type the bank',
    'modal.cSwift': 'SWIFT / BIC code',
    'modal.cAba': 'ABA or routing number (optional)',
    'modal.cGuardar': 'Save account',
    'modal.mOficinas': 'Master Money Offices',
    'modal.mOficina': 'Office',
    'modal.mComoLlegar': 'Get directions',
    'dep.oldEnviar': 'Send',
    'dep.oldTitulo': 'New deposit',
    'dep.oldSubtitulo': 'Select the type of deposit to make',
    'dep.oldTodos': 'All my deposits',
    'dep.oldListado': 'List of deposits',
    'dep.oldAch': 'ACH / PANAMA',
    'dep.oldBancaInt': 'International bank transfer',
    'dep.oldInfoTodos': 'Your deposits to date',
    'dep.oldInfoInt': 'To report deposits made to the Panther account abroad...',
    'dep.oldInfoAch': 'To report deposits via ACH / PANAMA...',
    'dep.oldTipCodigo': 'Reference code',
    'dep.oldTipFecha': 'Deposit date',
    'dep.oldTipInfo': 'Deposit information',
    'dep.oldTipMoneda': 'Currency',
    'dep.oldTipMonto': 'Amount',
    'dep.oldTipEstado': 'Movement status',
    'dep.oldColCodigo': 'CODE',
    'dep.oldColFecha': 'DATE',
    'dep.oldColInfo': 'INFORMATION',
    'dep.oldColMoneda': 'CURRENCY',
    'dep.oldColMonto': 'AMOUNT',
    'dep.oldColEstado': 'MOVEMENT STATUS',
    'dep.oldListaTitulo': 'All your deposits',
    'dep.oldSinDep': 'No deposits',
    'dep.oldSinDepSub': 'You haven\'t made any deposits yet',
    'dep.oldSinDepAyuda': 'To deposit money into your Panther7 account, please select the type of transfer and follow the steps.',
    'dep.oldRegistrarInt': 'REGISTER TRANSFER NEW ADDRESS',
    'dep.oldBancoReceptor': 'Receiving Bank:',
    'dep.oldBancoBenef': 'Beneficiary Bank:',
    'dep.oldNumCuenta': 'Account Number:',
    'dep.oldCreditoAd': 'Further Credit to:',
    'dep.oldRefCredito': 'Credit Reference:',
    'dep.oldHaciendo': 'You are making a deposit for the amount',
    'dep.oldMonto': 'Amount',
    'dep.oldElegirMoneda': 'Choose Currency',
    'dep.oldPhMonto': 'Enter the amount',
    'dep.oldPhMontoEnviar': 'Enter the amount to send',
    'dep.oldMoneda': 'Currency',
    'dep.oldCargarComp': 'Upload the receipt',
    'dep.oldEjem': 'e.g. .JPG .PDF \'Maximum file size: 4mb\'',
    'dep.oldRegistrarAch': 'REGISTER ACH / PANAMA DEPOSIT',
    'dep.oldMax1': 'The maximum amount per deposit is',
    'dep.old3000': '3000 USDT',
    'dep.oldMax2': 'For deposits greater than',
    'dep.oldMax3': 'contact us at info@panther7.com',
    'dep.oldDemo': 'This is a demo platform; the balance and operations are not real.',
    'dep.oldPaypal': 'Pay with PayPal',
    'dep.oldPaypalRapida': 'The fastest and safest way to pay',
    'dep.oldPaypalComision': 'PayPal deposits have an operating fee of 5.5%.',
    'dep.oldPaypalEjemplo': 'For example: if you deposit $100, $94.5 will be credited to your Panther7 account.',
    'dep.oldRemesadora': 'DEPOSIT VIA REMITTANCE SERVICE',
    'dep.oldPasos': 'Steps to make the deposit via Master Money',
    'dep.oldPaso1': 'Go to the nearest Master Money. See the list of offices',
    'dep.oldPaso2': 'You must bring a valid ID.',
    'dep.oldPaso3': 'Give the Master Money operator the authorization number (PantherPIN)',
    'dep.oldPaso4': 'Hand the Master Money operator the amount you are sending as a deposit',
    'dep.oldPaso5': 'Once your remittance is processed, get your copy of the transfer receipt and your deposit will be available in your Panther7 wallet in cash within a maximum of 30 minutes.',
    'dep.oldPaso6': 'All the information will be sent by email',
    'dep.oldAceptar': 'OK',
    'srv:Tiene un depósito en tránsito. Verifique depósitos ya generados': 'You have a deposit in progress. Check the deposits already created.',
    'srv:Depósito reportado con éxito': 'Deposit reported successfully',
    'srv:Seleccione una wallet USDT guardada en su cuenta.': 'Select a USDT wallet saved in your account.',
    'srv:Solicitud de retiro creado con éxito': 'Withdrawal request created successfully',
    'srv:Saldo insuficiente': 'Insufficient balance',
    'srv:Retiro creado con exito': 'Withdrawal created successfully',
    'srv:En las próximas 24 horas su solicitud de transferencia será procesada.': 'Your transfer request will be processed within the next 24 hours.',
  },
  pt: {
    'dep.copiar': 'Copiar',
    'dep.copiado': 'Copiado',
    'dep.estAprobado': 'Aprovado',
    'dep.estRechazado': 'Rejeitado',
    'dep.estRevision': 'Em análise',
    'dep.tipoInternacional': 'Transferência internacional',
    'dep.tipoRemesa': 'Remessa',
    'dep.tipoAchPanama': 'ACH Panamá',
    'dep.vacioTitulo': 'Você ainda não tem depósitos.',
    'dep.vacioAyuda': 'Envie USDT para um endereço da Panther7 e nos avise no passo 2 para creditarmos.',
    'dep.buscar': 'Buscar por data, status ou valor',
    'dep.buscarAria': 'Buscar depósitos',
    'dep.paginas': 'Páginas',
    'dep.pagAnterior': 'Página anterior',
    'dep.pagSiguiente': 'Próxima página',
    'dep.pagina': '{pagina} de {maximo}',
    'dep.colFecha': 'Data',
    'dep.colDetalle': 'Detalhes',
    'dep.colMonto': 'Valor',
    'dep.colEstado': 'Status',
    'dep.motivo': 'Motivo: {motivo}',
    'dep.depositoUno': '{n} depósito',
    'dep.depositoVarios': '{n} depósitos',
    'dep.titulo': 'Depósito',
    'dep.subtitulo': 'Selecione uma opção para continuar',
    'dep.tabMis': 'Meus depósitos',
    'dep.tabDonde': 'USDT: para onde enviar',
    'dep.tabAvisar': 'USDT: avisar meu envio',
    'dep.tabAch': 'ACH Panamá',
    'dep.achArchivoGrande': 'O arquivo não deve ultrapassar 4 MB.',
    'dep.achFormato': 'Use um arquivo JPG, PNG ou PDF.',
    'dep.achSinComprobante': 'Anexe o comprovante da transferência.',
    'dep.achReportado': 'Depósito informado.',
    'dep.achNoSePudo': 'Não foi possível informar o depósito. Tente novamente.',
    'dep.achRevisamos': 'Vamos revisá-lo e creditá-lo na sua carteira em USDT (1 para 1). Você verá o status em "Meus depósitos".',
    'dep.achReportarOtro': 'Informar outro',
    'dep.achVerMis': 'Ver meus depósitos',
    'dep.achPaso1': '1. Transfira para esta conta',
    'dep.cargandoDatos': 'Carregando dados…',
    'dep.achSinDatos': 'Os dados bancários ainda não estão disponíveis. Fale com o suporte para recebê-los.',
    'dep.achBanco': 'Banco',
    'dep.achTitular': 'Titular',
    'dep.achCuenta': 'Conta',
    'dep.achCuentaTipo': 'Conta ({tipo})',
    'dep.achAyuda': 'Seu depósito é creditado 1 para 1 em USDT. Transfira de uma conta no seu nome.',
    'dep.achPaso2': '2. Avise-nos quando enviar',
    'dep.achMonto': 'Valor transferido (USDT)',
    'dep.achPhMonto': 'Ex.: 500.00',
    'dep.achBancoOrigen': 'Banco de onde você enviou',
    'dep.achPhBanco': 'Digite ou escolha seu banco',
    'dep.achFecha': 'Data da transferência',
    'dep.achReferencia': 'Número de referência ou confirmação',
    'dep.achComprobante': 'Comprovante (JPG, PNG ou PDF, máx. 4 MB)',
    'dep.enviando': 'Enviando…',
    'dep.achReportar': 'Informar depósito',
    'dep.dirError': 'Erro ao carregar os endereços. Por favor, tente novamente.',
    'dep.noDisponible': 'Indisponível',
    'dep.cargandoSr': 'Carregando...',
    'dep.dirCargando': 'Carregando endereços de depósito...',
    'dep.reintentar': 'Tentar novamente',
    'dep.dirNinguna': 'Não há endereços disponíveis',
    'dep.dirColDireccion': 'Endereço',
    'dep.dirColAccion': 'Ação',
    'dep.dirColNetwork': 'Rede',
    'dep.dirAyuda1': 'Para creditar USDT na sua carteira, utilize um dos endereços estabelecidos.',
    'dep.dirAyuda2': 'Depois de enviar os USDT, siga os passos em',
    'dep.dirAyuda3': 'Os relatórios de depósito serão processados em no máximo',
    'dep.dirHoras': '6 horas úteis',
    'dep.ejMonto100': 'Ex.: 100.00',
    'dep.archivoGrande4': 'O arquivo não deve ultrapassar 4MB',
    'dep.formatoNoPermitido': 'Formato não permitido. Use JPG, PNG ou PDF',
    'dep.montoInvalido': 'Por favor, informe um valor válido',
    'dep.sinComprobante': 'Por favor, envie o comprovante da transação',
    'dep.errorSolicitud': 'Erro ao processar a solicitação',
    'dep.reportarBtn': '📤 Informar Depósito',
    'dep.estaReportando': '💰 Você está informando um depósito de',
    'dep.comprobante': 'Comprovante',
    'dep.clickCargar': 'Clique ou arraste para enviar o comprovante',
    'dep.formatosPermitidos': 'Formatos permitidos: JPG, PNG, PDF. Tamanho máximo: 4MB',
    'dep.panTitulo': 'Informar Depósitos',
    'dep.panSub': 'Faça uma transferência cripto para o endereço indicado e informe sua transação',
    'dep.panReqMonto': '💰 Valor',
    'dep.panReqMontoSub': 'Valor enviado em USDT',
    'dep.panReqDir': '📍 Endereço USDT',
    'dep.panReqDirSub': 'Endereço para onde você enviou os fundos',
    'dep.panReqHash': '🔗 Hash',
    'dep.panReqHashSub': 'Hash gerado pela transação',
    'dep.panReqComp': '📎 Comprovante',
    'dep.panReqCompSub': 'Imagem ou PDF da transação',
    'dep.panMonto': 'Valor (USDT)',
    'dep.panCualDir': 'Para qual endereço da Panther você enviou?',
    'dep.panSelDir': 'Selecione o endereço',
    'dep.panDirAyuda': 'É o endereço que lhe demos para depositar, não o seu. Assim sabemos em qual rede chegou.',
    'dep.panHashLabel': 'Hash da Transação',
    'dep.panHashPh': 'Hash da transação na blockchain',
    'dep.panSelDirMsg': 'Selecione o endereço da Panther para o qual você enviou',
    'dep.panHashMsg': 'Por favor, informe o hash da transação',
    'dep.vistaPrevia': 'Pré-visualização',
    'dep.intTitulo': 'Transferência Internacional',
    'dep.intIntro1': 'Preencha as informações a seguir para informar sua transferência internacional.',
    'dep.intIntro2': 'Você deverá informar o',
    'dep.intIntroMonto': 'valor',
    'dep.intIntroUna': 'uma',
    'dep.intIntroRef': 'referência',
    'dep.intIntroAdj': 'e anexar o',
    'dep.intIntroComp': 'comprovante bancário',
    'dep.intMonto': 'Valor (USDT)',
    'dep.intRef': 'Referência',
    'dep.intPhRef': 'Ex.: TRANSFER-12345',
    'retiro.error': 'Erro ao processar o saque',
    'retiro.solicitarBtn': 'Solicitar Saque',
    'retiro.titulo': 'Novo saque',
    'retiro.subtitulo': 'Selecione o tipo de saque a realizar',
    'retiro.todos': 'Todos os meus saques',
    'retiro.listado': 'Lista de saques',
    'retiro.nacional': 'Transferência Nacional',
    'retiro.panama': 'Panamá',
    'retiro.internacional': 'Transferência Internacional',
    'retiro.global': 'Global',
    'retiro.cripto': 'Transferência Cripto',
    'retiro.infoTodos': 'Seus saques feitos até o momento',
    'retiro.infoNacional': 'Para fazer saques para contas nacionais no Panamá',
    'retiro.infoInternacional': 'Para fazer saques para contas internacionais em todo o mundo',
    'retiro.infoCripto': 'Para fazer saques via cripto USDT',
    'retiro.listaTitulo': 'Todos os seus saques',
    'retiro.colCodigo': 'CÓDIGO',
    'retiro.colFecha': 'DATA',
    'retiro.colBeneficiario': 'BENEFICIÁRIO',
    'retiro.colInfo': 'INFORMAÇÃO',
    'retiro.colMoneda': 'MOEDA',
    'retiro.colMonto': 'VALOR',
    'retiro.colEstado': 'STATUS',
    'retiro.colBanco': 'BANCO',
    'retiro.colTitular': 'TITULAR',
    'retiro.colCuenta': 'CONTA',
    'retiro.colTipo': 'TIPO',
    'retiro.colSeleccion': 'SELEÇÃO',
    'retiro.colNombre': 'NOME',
    'retiro.colRed': 'REDE',
    'retiro.colDireccion': 'ENDEREÇO',
    'retiro.selBeneficiario': 'Selecione o beneficiário',
    'retiro.addBeneficiario': 'Adicionar beneficiário',
    'retiro.retirar': 'Sacar',
    'retiro.retirarUsdt': 'Sacar USDT',
    'retiro.nuevaWallet': '+ Nova carteira',
    'retiro.sinWallets': 'Você ainda não tem carteiras salvas.',
    'retiro.sinWalletsAyuda': 'Adicione a carteira onde você quer receber seus USDT.',
    'retiro.primeraWallet': 'Adicionar minha primeira carteira',
    'srv:TRANSFERENCIA NACIONAL': 'TRANSFERÊNCIA NACIONAL',
    'srv:TRANSFERENCIA INTERNACIONAL': 'TRANSFERÊNCIA INTERNACIONAL',
    'wallet.noAsignada': 'Não atribuída',
    'wallet.estCompletada': 'Concluída',
    'wallet.estPendiente': 'Pendente',
    'wallet.estFallida': 'Falhou',
    'wallet.titulo': 'Minha carteira',
    'wallet.subtitulo': 'Seu saldo em USDT e cada movimentação de tokens, registrados na blockchain.',
    'wallet.tarjetaAria': 'Cartão da carteira',
    'wallet.redPruebas': 'Rede de testes Sepolia',
    'wallet.saldo': 'Saldo disponível',
    'wallet.titular': 'Titular',
    'wallet.sinUsuario': 'Sem usuário atribuído',
    'wallet.direccion': 'Endereço',
    'wallet.copiada': 'Copiado',
    'wallet.copiar': 'Copiar',
    'wallet.ver': 'Ver',
    'wallet.totalTransferido': 'Total transferido',
    'wallet.completadas': 'Concluídas',
    'wallet.pendientes': 'Pendentes',
    'wallet.nota': 'Você está em uma rede de testes: estes tokens não têm valor real.',
    'wallet.historial': 'Histórico de transferências',
    'wallet.enTotal': '{n} no total',
    'wallet.sinTransferencias': 'Nenhuma transferência ainda',
    'wallet.sinTransferenciasAyuda': 'Quando você investir ou vender, cada movimentação de tokens aparecerá aqui.',
    'wallet.proyecto': 'Projeto #{id}',
    'wallet.para': 'Para {usuario} · ',
    'wallet.verMenos': 'Ver menos',
    'wallet.verTodas': 'Ver as {n}',
    'modal.retiroAria': 'Solicitar saque',
    'modal.cerrar': 'Fechar',
    'modal.retirarUsdt': 'Sacar USDT',
    'modal.retirarBanco': 'Sacar para conta bancária',
    'modal.seEnviaWallet': 'Será enviado para uma carteira que você já salvou.',
    'modal.seEnviaCuenta': 'Será enviado para uma conta que você já salvou.',
    'modal.wallet': 'Carteira',
    'modal.red': 'Rede',
    'modal.direccion': 'Endereço',
    'modal.banco': 'Banco',
    'modal.tipoCuenta': 'Tipo de conta',
    'modal.titular': 'Titular',
    'modal.numCuenta': 'Número da conta',
    'modal.cuantoRetirar': 'Quanto você quer sacar?',
    'modal.disponible': 'Disponível:',
    'modal.retirarTodo': 'Sacar tudo',
    'modal.excede': 'O valor excede seu saldo disponível.',
    'modal.recibirasWallet': 'Você receberá na sua carteira',
    'modal.seEnviaATuCuenta': 'Será enviado para sua conta',
    'modal.nota1': 'A Panther7 não cobra comissão por saques.',
    'modal.nota2': 'A rede pode cobrar uma taxa ao executar o envio.',
    'modal.nota3': 'Você verá o valor refletido em no máximo 24 horas úteis.',
    'modal.cancelar': 'Cancelar',
    'modal.enviando': 'Enviando…',
    'modal.solicitarRetiro': 'Solicitar saque',
    'modal.wDirCorta': 'Confira o endereço: parece incompleto.',
    'modal.wNoGuardada': 'Não foi possível salvar a carteira. Tente novamente.',
    'modal.wTitulo': 'Nova carteira USDT',
    'modal.wAyuda': 'Você só poderá sacar para carteiras salvas aqui. Confira bem a rede e o endereço: um envio para a rede errada não pode ser recuperado.',
    'modal.wAlias': 'Nome para reconhecê-la',
    'modal.wAliasPh': 'Ex.: Minha carteira Binance',
    'modal.wDirLabel': 'Endereço da carteira',
    'modal.wDirPh': 'Cole o endereço completo',
    'modal.guardando': 'Salvando…',
    'modal.wGuardar': 'Salvar carteira',
    'modal.cAhorros': 'Poupança',
    'modal.cCorriente': 'Corrente',
    'modal.cCuentaCorta': 'Confira o número da conta: parece incompleto.',
    'modal.cSelPais': 'Selecione o país do banco.',
    'modal.cNoGuardada': 'Não foi possível salvar a conta. Tente novamente.',
    'modal.cTituloInt': 'Nova conta internacional',
    'modal.cTituloNac': 'Nova conta no Panamá',
    'modal.cAyudaInt': 'Conta bancária fora do Panamá. Confira o SWIFT e o número da conta antes de salvar.',
    'modal.cAyudaNac': 'Conta bancária em seu nome em um banco do Panamá.',
    'modal.cTitular': 'Titular da conta',
    'modal.cPais': 'País do banco',
    'modal.cSelPaisOpt': 'Selecione um país',
    'modal.cBancoPh': 'Escolha ou digite o banco',
    'modal.cSwift': 'Código SWIFT / BIC',
    'modal.cAba': 'ABA ou rota (opcional)',
    'modal.cGuardar': 'Salvar conta',
    'modal.mOficinas': 'Escritórios Master Money',
    'modal.mOficina': 'Escritório',
    'modal.mComoLlegar': 'Como chegar',
    'dep.oldEnviar': 'Enviar',
    'dep.oldTitulo': 'Novo depósito',
    'dep.oldSubtitulo': 'Selecione o tipo de depósito a realizar',
    'dep.oldTodos': 'Todos os meus depósitos',
    'dep.oldListado': 'Lista de depósitos',
    'dep.oldAch': 'ACH / PANAMÁ',
    'dep.oldBancaInt': 'Transferência bancária internacional',
    'dep.oldInfoTodos': 'Seus depósitos feitos até o momento',
    'dep.oldInfoInt': 'Para informar depósitos feitos na conta Panther no exterior...',
    'dep.oldInfoAch': 'Para informar depósitos via ACH / PANAMÁ...',
    'dep.oldTipCodigo': 'Código de referência',
    'dep.oldTipFecha': 'Data do depósito',
    'dep.oldTipInfo': 'Informações do depósito',
    'dep.oldTipMoneda': 'Moeda',
    'dep.oldTipMonto': 'Valor',
    'dep.oldTipEstado': 'Status da movimentação',
    'dep.oldColCodigo': 'CÓDIGO',
    'dep.oldColFecha': 'DATA',
    'dep.oldColInfo': 'INFORMAÇÃO',
    'dep.oldColMoneda': 'MOEDA',
    'dep.oldColMonto': 'VALOR',
    'dep.oldColEstado': 'STATUS DA MOVIMENTAÇÃO',
    'dep.oldListaTitulo': 'Todos os seus depósitos',
    'dep.oldSinDep': 'Sem depósitos',
    'dep.oldSinDepSub': 'Você ainda não fez nenhum depósito',
    'dep.oldSinDepAyuda': 'Para depositar dinheiro na sua conta Panther7, selecione o tipo de envio e siga os passos.',
    'dep.oldRegistrarInt': 'REGISTRAR TRANSFERÊNCIA NOVO ENDEREÇO',
    'dep.oldBancoReceptor': 'Banco Receptor:',
    'dep.oldBancoBenef': 'Banco Beneficiário:',
    'dep.oldNumCuenta': 'Número da Conta:',
    'dep.oldCreditoAd': 'Crédito Adicional para:',
    'dep.oldRefCredito': 'Referência de Crédito:',
    'dep.oldHaciendo': 'Você está fazendo um depósito no valor de',
    'dep.oldMonto': 'Valor',
    'dep.oldElegirMoneda': 'Escolher Moeda',
    'dep.oldPhMonto': 'Digite o valor',
    'dep.oldPhMontoEnviar': 'Digite o valor a enviar',
    'dep.oldMoneda': 'Moeda',
    'dep.oldCargarComp': 'Enviar o comprovante',
    'dep.oldEjem': 'Ex.: .JPG .PDF \'Tamanho máximo do arquivo: 4mb\'',
    'dep.oldRegistrarAch': 'REGISTRAR DEPÓSITO ACH / PANAMÁ',
    'dep.oldMax1': 'O valor máximo por depósito é de',
    'dep.old3000': '3000 USDT',
    'dep.oldMax2': 'Para depósitos acima de',
    'dep.oldMax3': 'entre em contato pelo e-mail info@panther7.com',
    'dep.oldDemo': 'Esta é uma plataforma de demonstração; o saldo e as operações não são reais.',
    'dep.oldPaypal': 'Pagar com PayPal',
    'dep.oldPaypalRapida': 'A forma mais rápida e segura de pagar',
    'dep.oldPaypalComision': 'Os depósitos via PayPal têm uma comissão operacional de 5,5%.',
    'dep.oldPaypalEjemplo': 'Por exemplo: se você depositar $100, serão creditados na sua conta Panther7: $94.5',
    'dep.oldRemesadora': 'DEPÓSITO VIA REMESSA',
    'dep.oldPasos': 'Passos para realizar o depósito via Master Money',
    'dep.oldPaso1': 'Dirija-se ao Master Money mais próximo. Veja a lista de escritórios',
    'dep.oldPaso2': 'Você deve ir com um documento de identificação válido.',
    'dep.oldPaso3': 'Informe ao operador do Master Money o número de autorização (PantherPIN)',
    'dep.oldPaso4': 'Entregue ao operador do Master Money o valor do seu envio para depósito',
    'dep.oldPaso5': 'Ao processar sua remessa, receba sua via do comprovante de envio e seu depósito estará disponível em dinheiro na sua carteira Panther7 em no máximo 30 minutos.',
    'dep.oldPaso6': 'Todas as informações serão enviadas por e-mail',
    'dep.oldAceptar': 'OK',
    'srv:Tiene un depósito en tránsito. Verifique depósitos ya generados': 'Você tem um depósito em andamento. Verifique os depósitos já gerados.',
    'srv:Depósito reportado con éxito': 'Depósito informado com sucesso',
    'srv:Seleccione una wallet USDT guardada en su cuenta.': 'Selecione uma carteira USDT salva na sua conta.',
    'srv:Solicitud de retiro creado con éxito': 'Solicitação de saque criada com sucesso',
    'srv:Saldo insuficiente': 'Saldo insuficiente',
    'srv:Retiro creado con exito': 'Saque criado com sucesso',
    'srv:En las próximas 24 horas su solicitud de transferencia será procesada.': 'Sua solicitação de transferência será processada nas próximas 24 horas.',
  },
};
